import * as actions from './Actions.js';

import { Col, Row } from 'react-bootstrap';
import {
  onChange,
  resetCrud
} from 'portaltransparencia-common/crud/Actions.js';

import Component from 'react-pure-render/component';
import ExportButtonGroup from 'portaltransparencia-common/components/ExportButtonGroup.react.js';
import FilterButtons from '../components/FilterButtons.react.js';
import Input from 'portaltransparencia-common/components/EloInput.react.js';
import { Map } from 'immutable';
import NotasExplicativas from '../notaexplicativa/Form.react.js';
import PageHeader from '../components/PageHeader.react.js';
import Panel from 'portaltransparencia-common/components/Panel.react.js';
import PropTypes from 'prop-types';
import React from 'react';
import SearchPagination from 'portaltransparencia-common/components/SearchPagination.react.js';
import StorageService from 'portaltransparencia-common/libs/StorageService.js';
import TableActions from 'portaltransparencia-common/components/TableActions.react.js';
import TableHeader from 'portaltransparencia-common/components/TableHeader.react';
import TableHeaderItem from 'portaltransparencia-common/components/TableHeaderItem.react';
import UltimaAtualizacao from '../ultimaatualizacao/Form.react.js';
import { addErrorNotification } from 'portaltransparencia-common/ui/Actions.js';
import configuration from 'portaltransparencia-common/config/Config.js';
import { connect } from 'react-redux';

export class FormLicitacaoParticipantes extends Component {
  static propTypes = {
    page: PropTypes.object.isRequired,
    findParticipantes: PropTypes.func.isRequired,

    filtros: PropTypes.object,
    onChange: PropTypes.func,
    onChangeFieldValue: PropTypes.func,
    location: PropTypes.object.isRequired,
    resetCrud: PropTypes.func.isRequired,
    addErrorNotification: PropTypes.func.isRequired
  };

  consultarParticipantes = () => {
    const { page } = this.props;
    const initialPage = page.set('number', 0);

    this.onConsultaWithPage(initialPage);
  };

  onConsultaParticipantes = () => {
    this.consultarParticipantes();
    this.refs.panelFiltroParticipantes &&
      this.refs.panelFiltroParticipantes.collapse();
  };

  onConsultaWithPage = page => {
    let filter = this.montaFiltro(page);
    const { findParticipantes } = this.props;

    findParticipantes(filter);
  };

  onChangeFiltro = event => {
    const { onChange } = this.props;
    onChange('filtroParticipante', event);
  };

  onResetFiltro = () => {
    const { findParticipantes, resetCrud } = this.props;
    resetCrud('filtroParticipante');

    findParticipantes('');
  };

  onExporta = (exportType, openTab, windowParams) => {
    const { page, addErrorNotification } = this.props;
    const { apiURL } = configuration;

    if (!page.get('content').isEmpty()) {
      let filtro = this.montaFiltro(page);

      window.open(
        `${apiURL}/api/licitacoes/participantes/report/${exportType}?${filtro}`,
        openTab,
        windowParams
      );
    } else {
      addErrorNotification(
        'A consulta não apresentou resultado. Não é possível exportar para o formato selecionado!'
      );
    }
  };

  montaFiltro = page => {
    const { entidade, exercicio } = StorageService.getItem('userInfo');
    const { filtros } = this.props;

    const escapeRsql = val => `"*${String(val).replace(/"/g, '\\"')}*"`;

    const filters = [
      `licitacao.entidade==${entidade.id}`,
      `licitacao.exercicio==${exercicio.id}`
    ];

    const addIfPresent = (key, expression) => {
      const value = filtros.get(key);
      if (value) filters.push(expression(value));
    };

    addIfPresent('razaoSocial', v => `fornecedor.nome==${escapeRsql(v)}`);
    addIfPresent(
      'nomeFantasia',
      v => `fornecedor.nomeFantasia==${escapeRsql(v)}`
    );
    addIfPresent('cnpj', v => `fornecedor.cnpjCpf==${v}`);
    addIfPresent('numeroLicitacao', v => `licitacao.numeroLicitacao==${v}`);

    const params = new URLSearchParams();
    params.append('search', filters.join(';'));

    const number = page?.get('number') ?? 0;
    const size = page?.get('size') ?? 20;
    const sortField = page?.get('sort') ?? 'fornecedor.nome,asc';

    params.append('page', number);
    params.append('size', size);
    params.append('sort', `${sortField}`);

    return params.toString();
  };

  onViewParticipante = data => {
    this.props.history.push(
      `/participantes-licitacao/detalhes?pessoa=${data.get('pessoa')}`,
      {
        pessoa: data.get('pessoa'),
        razaoSocial: data.get('razaoSocial'),
        nomeFantasia: data.get('nomeFantasia'),
        cnpj: data.get('cnpj')
      }
    );
  };

  renderParticipantes = data => {
    return (
      <TableActions
        ref="row"
        key={data.get('pessoa')}
        data={data}
        onMore={this.onViewParticipante}
      >
        <td>{data.get('razaoSocial')}</td>
        <td>{data.get('nomeFantasia')}</td>
        <td>{data.get('cnpj')}</td>
      </TableActions>
    );
  };

  render() {
    const { page, filtros, location } = this.props;

    return (
      <section>
        <PageHeader location={location} />

        <NotasExplicativas pathname={this.props.location.pathname} />

        <Panel
          isForm
          mobileClose
          title="Consulta"
          ref="panelFiltroParticipantes"
        >
          <form>
            <Row>
              <Col xs={12} sm={6} md={6}>
                <Input
                  id="razaoSocial"
                  name="razaoSocial"
                  ref="razaoSocial"
                  placeholder="Razão Social"
                  label="Razão Social"
                  type="text"
                  onChange={this.onChangeFiltro}
                  value={filtros.get('razaoSocial')}
                />
              </Col>
              <Col xs={12} sm={6} md={6}>
                <Input
                  id="nomeFantasia"
                  name="nomeFantasia"
                  ref="nomeFantasia"
                  placeholder="Nome Fantasia"
                  label="Nome Fantasia"
                  type="text"
                  onChange={this.onChangeFiltro}
                  value={filtros.get('nomeFantasia')}
                />
              </Col>
              <Col xs={12} sm={2} md={4}>
                <Input
                  id="cnpj"
                  name="cnpj"
                  ref="cnpj"
                  placeholder="CNPJ/CPF"
                  label="CNPJ/CPF"
                  type="text"
                  onChange={this.onChangeFiltro}
                  value={filtros.get('cnpj')}
                />
              </Col>
              <Col xs={12} sm={2} md={2}>
                <Input
                  id="numeroLicitacao"
                  name="numeroLicitacao"
                  ref="numeroLicitacao"
                  placeholder="Nº Licitação"
                  label="Nº Licitação"
                  type="number"
                  onChange={this.onChangeFiltro}
                  value={filtros.get('numeroLicitacao')}
                />
              </Col>
              <Col xs={12} sm={4} md={4}>
                <FilterButtons
                  idBtnReset="btnResetFilter"
                  onConsulta={this.onConsultaParticipantes}
                  onReset={this.onResetFiltro}
                />
              </Col>
            </Row>
          </form>
        </Panel>

        {page.get('content') && (
          <Panel isForm tableResponsive expansible={false}>
            <Row>
              <Col xs={6}>
                <UltimaAtualizacao modulo="3" />
              </Col>
              <Col xs={6} />
            </Row>

            <Row>
              <Col xs={6} />
              <Col xs={6}>
                <ExportButtonGroup onClick={this.onExporta} visible={true} />
              </Col>
            </Row>

            <div className="panel-table-outer">
              <table className="panel-table striped fancy">
                <TableHeader
                  empty={page.get('content').isEmpty()}
                  text="Sem registros"
                >
                  <tr>
                    <TableHeaderItem
                      field="fornecedor.nome"
                      label="Razão Social"
                      page={page}
                      searchWithPage={this.onConsultaWithPage}
                      alignment="left"
                    />
                    <TableHeaderItem
                      field="fornecedor.nomeFantasia"
                      label="Nome Fantasia"
                      page={page}
                      searchWithPage={this.onConsultaWithPage}
                      alignment="left"
                    />
                    <TableHeaderItem
                      field="fornecedor.cnpjCpf"
                      label="CNPJ/CPF"
                      page={page}
                      searchWithPage={this.onConsultaWithPage}
                      alignment="left"
                    />
                    <th />
                  </tr>
                </TableHeader>
                <tbody>
                  {page.get('content').map(this.renderParticipantes)}
                </tbody>
              </table>
            </div>

            <SearchPagination
              page={page}
              searchWithPage={this.onConsultaWithPage}
            />
          </Panel>
        )}
      </section>
    );
  }
}

function mapStateToProps(state) {
  return {
    filtros: state.crud.getIn(['filtroParticipante', 'currentRecord'], Map({})),
    page: state.licitacoesParticipantes.get('participantes')
  };
}

const allActions = {
  ...actions,
  onChange,
  resetCrud,
  addErrorNotification
};

export default connect(mapStateToProps, allActions)(FormLicitacaoParticipantes);
